const testimonials = [
  {
    name: "Derek O.",
    location: "Idaho Falls, ID",
    rating: 5,
    text: "Planning a Yellowstone trip that required a Canadian border crossing, and my passport had expired. Fast Passport Center got my renewal processed in 5 days. Unreal how fast and stress-free it was.",
    service: "Expedited Renewal",
  },
  {
    name: "Michelle R.",
    location: "Ammon, ID",
    rating: 5,
    text: "Applying for my kids' passports for the first time was daunting. The agent explained everything clearly, told me exactly what to bring to the Bonneville County Clerk, and we got both passports in under 2 weeks.",
    service: "Child Passport",
  },
  {
    name: "Steve W.",
    location: "Rexburg, ID",
    rating: 5,
    text: "I'm a BYU-Idaho professor who travels internationally every summer. Fast Passport Center has been my go-to for renewals for 3 years now. Always fast, always accurate. Never had a single problem.",
    service: "Expedited Renewal",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Idaho Falls Travelers Are Saying
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Real customers from Idaho Falls, Ammon, Rexburg, Pocatello, and the surrounding area.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}